var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.5 3.989-.711.711-1.275-1.275v6.83H7.509v-6.83L6.233 4.7l-.711-.71L8.01 1.5zm-9 4.489.711-.711 1.276 1.275V2.211h1.005v6.831l1.274-1.275.712.711-2.489 2.489z",
    clipRule: "evenodd"
  })));
});
const SvgTransferUpDownsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransferUpDownsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC41IDMuOTg5TDkuNzg5IDQuN0w4LjUxNCAzLjQyNVYxMC4yNTVINy41MDg1VjMuNDI1TDYuMjMzNSA0LjdMNS41MjI1IDMuOTg5NUw4LjAxMSAxLjVMMTAuNSAzLjk4OVpNMS41IDguNDc4TDIuMjExIDcuNzY3TDMuNDg2NSA5LjA0MlYyLjIxMUg0LjQ5MTVWOS4wNDJMNS43NjY1IDcuNzY3TDYuNDc3NSA4LjQ3OEwzLjk4OSAxMC45NjY1TDEuNSA4LjQ3OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";